export default {
  name: 'marking--orderCheckKM',
  apiService: 'shoes',
  apiPath: '/admin/order/func/update_statuses',
  urlParamName: 'marking--orderCheckKM',
};